import { Button, Result } from 'antd';
import { useAppSelector } from 'presentation/redux/hooks';
import { AUTH_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';

const Unauthorized = () => {
    const userSlice = useAppSelector((state) => state.user);
    const navigate = useNavigate();

    const toSigninPage = () => {
        navigate(AUTH_ROUTES.PATH + '/' + AUTH_ROUTES.SUB.CU_001_00);
    };

    const backToPrevPage = () => {
        navigate(-1);
    };

    if (!userSlice?.isSignedIn) {
        return (
            <Result
                status="403"
                title="403"
                subTitle={getMessage('E0781')}
                extra={
                    <Button type="primary" onClick={toSigninPage}>
                        ログイン
                    </Button>
                }
            />
        );
    }

    return (
        <Result
            status="403"
            title="403"
            subTitle={getMessage('E0781')}
            extra={
                <Button type="primary" onClick={backToPrevPage}>
                    戻る
                </Button>
            }
        />
    );
};

export default Unauthorized;
